import React from 'react';

import {
  layout,
  PermissionWall,
  widgets
} from 'modules';



export interface IProps {
  storeId: string;
  orderId: string;
}

export const FC: React.FC<IProps> = props => {
  return (
    <layout.ColumnBox>
      <layout.RowBox>
        <layout.ColumnBox>
          <layout.RowBox>
            <widgets.order.PartnerActionsWidget.FC
              storeId={props.storeId}
              orderId={props.orderId} />
          </layout.RowBox>

          <layout.RowBox>
            <widgets.order.OrderSourceInformationWidget.FC orderId={props.orderId} />
            <widgets.order.PaymentInformationWidget.FC orderId={props.orderId} />
          </layout.RowBox>

          <layout.RowBox>
            <PermissionWall.FC
              storeId={props.storeId}
              requiresPermissions={['customer_viewCustomer']}>
              <widgets.order.CustomerInformationWidget.FC
                orderId={props.orderId}
                storeId={props.storeId} />
            </PermissionWall.FC>

            <PermissionWall.FC
              storeId={props.storeId}
              requiresPermissions={['salesOrder_viewShipment']}>
              <widgets.order.ShippingInformationWidget.FC orderId={props.orderId} />
            </PermissionWall.FC>

            <PermissionWall.FC
              storeId={props.storeId}
              requiresPermissions={['insurance_viewAppleCareAgreement']}>
              <widgets.order.AppleCareWidget.FC orderId={props.orderId} />
            </PermissionWall.FC>
          </layout.RowBox>

          <layout.RowBox>
            <PermissionWall.FC
              storeId={props.storeId}
              requiresPermissions={['inventory_viewProduct']}>
              <widgets.order.ProductInformationWidget.FC orderId={props.orderId} />
            </PermissionWall.FC>

            <PermissionWall.FC
              storeId={props.storeId}
              requiresPermissions={['itemFulfillment_view']}>
              <widgets.order.ScannedSerialNumbersWidget.FC
                storeId={props.storeId}
                orderId={props.orderId} />
            </PermissionWall.FC>
          </layout.RowBox>

          <layout.RowBox>
            <PermissionWall.FC
              storeId={props.storeId}
              requiresPermissions={['writeRequest_viewWriteRequest']}>
              <widgets.order.NetSuiteEligibilityWidget.FC orderId={props.orderId} />
            </PermissionWall.FC>
          </layout.RowBox>
        </layout.ColumnBox>

        <widgets.order.FulfillmentStatusWidget.PartnerFC orderId={props.orderId} />
      </layout.RowBox>

      <layout.RowBox>
        <PermissionWall.FC
          storeId={props.storeId}
          requiresPermissions={['salesOrder_viewMessages']}>
          <widgets.common.PartnerChatWidget.FC
            storeId={props.storeId}
            orderId={props.orderId} />
        </PermissionWall.FC>
      </layout.RowBox>

      {/* SendGrid Email Log */}
      <layout.RowBox>
        <PermissionWall.FC
          storeId={props.storeId}
          requiresPermissions={['customer_email']}>
          <widgets.common.SendGridEmailLogWidget.FC
            storeId={props.storeId}
            orderId={props.orderId} />
        </PermissionWall.FC>
      </layout.RowBox>

      <layout.RowBox>
        <PermissionWall.FC
          storeId={props.storeId}
          requiresPermissions={['salesOrder_viewAuditLogEvents']}>
          <widgets.common.AuditLogWidget.FC
            storeId={props.storeId}
            orderId={props.orderId} />
        </PermissionWall.FC>
      </layout.RowBox>
    </layout.ColumnBox >
  );
};
